import { useTranslation } from 'react-i18next';
import { cn } from '@anytag/shared-utils';
import { useUpdateDocumentTitle } from '@anytag/shared-hooks';
import { PaymentPlanType, usePricingTableQuery } from '@anytag/graphql';
import {
  PricingPlan,
  FeaturesTable,
  getSubscriptionFeatures,
  useTikTokAdvertiserSummaryData
} from '@anytag/shared-organisms';

export const TikTokSubscription = () => {
  useUpdateDocumentTitle({
    title: 'appHeader.Select Plan',
    appHeader: 'appHeader.Select Plan',
    href: '/tiktok-onboarding',
    alwaysBackToParent: true
  });
  const { t } = useTranslation();
  const { summaryData } = useTikTokAdvertiserSummaryData();
  const { data } = usePricingTableQuery({
    variables: {
      planType: PaymentPlanType.TIKTOK_ADS
    }
  });
  const subscriptionGroups = getSubscriptionFeatures(t);

  return (
    <div className="relative bg-white">
      <PricingPlan plans={data?.pricingTable?.plans || []} summaryData={summaryData} />
      <div className="px-4 pt-4">
        <h3 className={styles.sectionTitle}>{subscriptionGroups.group1.title}</h3>
        <FeaturesTable className={styles.table} features={subscriptionGroups.group1.features} />
      </div>
      <div className="px-4 pt-6">
        <h3 className={styles.sectionTitle}>{subscriptionGroups.group2.title}</h3>
        <FeaturesTable className={styles.table} features={subscriptionGroups.group2.features} />
      </div>
      <div className="px-4 pt-6">
        <h3 className={styles.sectionTitle}>{subscriptionGroups.group3.title}</h3>
        <FeaturesTable className={styles.table} features={subscriptionGroups.group3.features} />
      </div>
      <div className="px-4 pt-6">
        <h3 className={styles.sectionTitle}>{subscriptionGroups.group4.title}</h3>
        <FeaturesTable features={subscriptionGroups.group4.features} />
      </div>
    </div>
  );
};
const styles = {
  table: cn(
    '[&_.table-wrapper]:rounded-b-none',
    '[&_[data-slot="table-body"]_[data-slot="table-cell"]]:border-b',
    '[&_[data-slot="table-body"]_[data-slot="table-cell"]]:border-border'
  ),
  sectionTitle: cn('pb-4 text-base leading-[140%] font-semibold')
};
